import { render, staticRenderFns } from "./ChildDetail.vue?vue&type=template&id=02de10ca&"
import script from "./ChildDetail.vue?vue&type=script&lang=js&"
export * from "./ChildDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports